var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHit = function SvgHit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.194.254 1.404 4.907c.042.13.124.216.248.238l4.894 1.059c.268.065.35.41.144.605l-3.778 3.459c-.104.086-.145.237-.104.367l1.095 3.913c.082.28-.207.54-.454.41l-4.047-2.205a.27.27 0 0 0-.31.022l-4.584 2.918c-.227.152-.516-.043-.495-.324l.371-5.296c0-.086-.02-.194-.082-.26L.089 6.113c-.186-.216-.062-.562.206-.584l5.018-.475c.103 0 .185-.065.247-.152L8.616.146c.145-.238.496-.173.578.108"
  })));
};
export default SvgHit;